import React from 'react';
export const StatCard = ({
  label,
  value,
  icon,
  sub,
}: {
  label: string;
  value: React.ReactNode;
  icon: React.ReactNode;
  sub?: React.ReactNode;
}) => {
  return (
    <div className="flex-1 bg-slate-100 dark:bg-slate-800 rounded-lg px-3 py-2.5 min-w-0">
      <div className="flex items-center gap-1.5 text-xs text-slate-500 mb-0.5">
        <span className="text-slate-400 dark:text-slate-500">{icon}</span>
        {label}
      </div>
      <div className="text-lg font-semibold text-slate-900 dark:text-slate-100 truncate">
        {value}
      </div>
      {sub && (
        <div className="text-[10px] text-slate-400 dark:text-slate-600 truncate mt-0.5">
          {sub}
        </div>
      )}
    </div>
  );
};
